import { Skeleton, Stacker, TypographyBody } from '@honeycomb/ui-core';
import React from 'react';
export function FunnelStepperSkeleton() {
    return (React.createElement(Stacker, { direction: "row", spacing: 4, mt: 5, mb: 4 },
        React.createElement(TypographyBody, { component: "div" },
            React.createElement(Skeleton, { variant: "text", w: 80 })),
        React.createElement(TypographyBody, { component: "div" },
            React.createElement(Skeleton, { variant: "text", w: 120 })),
        React.createElement(TypographyBody, { component: "div" },
            React.createElement(Skeleton, { variant: "text", w: 100 }))));
}
